<h1 class="list-title">List Settings</h1>
<list-settings-about-panel></list-settings-about-panel>
<h2 class="list-subtitle">MANAGE LISTS</h2>
<list-settings-sublist
  [sublistTitle]="'My Groups'"
  [sublistItems]="groups"
  [selectedItem]="selectedSettingsGroup"
  [criteria]="'isSharedWithMe'"
  [criteriaValue]="false"
  [type]="'group'"
  [showDeleteCriteriaValue]="false"
  (selectItem)="settingsItemSelected.emit($event)"
  (confirmedDelete)="deleteGroupEvent.emit($event)"
  *ngIf="hasOwnGroups()"
>
</list-settings-sublist>
<list-settings-sublist
  [sublistTitle]="'Groups Shared With Me'"
  [sublistItems]="groups"
  [selectedItem]="selectedSettingsGroup"
  [criteria]="'isSharedWithMe'"
  [criteriaValue]="true"
  [showDeleteCriteriaValue]="false"
  (selectItem)="settingsItemSelected.emit($event)"
  (confirmedDelete)="deleteGroupEvent.emit($event)"
  *ngIf="hasSharedWithMeGroups()"
>
</list-settings-sublist>
<list-settings-sublist
  [sublistTitle]="'My Views'"
  [sublistItems]="views"
  [selectedItem]="selectedSettingsView"
  [criteria]="'isSharedWithMe'"
  [criteriaValue]="false"
  [type]="'view'"
  [showDeleteCriteriaValue]="false"
  (selectItem)="settingsItemSelected.emit($event)"
  (confirmedDelete)="deleteViewEvent.emit($event)"
  *ngIf="hasOwnViews()"
>
</list-settings-sublist>
<list-settings-sublist
  [sublistTitle]="'Views Shared With Me'"
  [sublistItems]="views"
  [selectedItem]="selectedSettingsView"
  [criteria]="'isSharedWithMe'"
  [criteriaValue]="true"
  [showDeleteCriteriaValue]="false"
  (selectItem)="settingsItemSelected.emit($event)"
  (confirmedDelete)="deleteViewEvent.emit($event)"
  *ngIf="hasSharedWithMeViews()"
>
</list-settings-sublist>
